/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Jobs_SelectedInputs */

const en_no_jobs_selected = /** @type {(inputs: No_Jobs_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No jobs selected.`)
};

const de_no_jobs_selected = /** @type {(inputs: No_Jobs_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Stellen ausgewählt.`)
};

/**
* | output |
* | --- |
* | "No jobs selected." |
*
* @param {No_Jobs_SelectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_jobs_selected = /** @type {((inputs?: No_Jobs_SelectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Jobs_SelectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_jobs_selected(inputs)
	return en_no_jobs_selected(inputs)
});